import {connect} from 'react-redux';
import Form_1 from './Form_1';
import {submitStep} from '../../actions/steps/submitStep';
import {uploadFile} from '../../actions/files/uploadFile';
import {getShumaStepStatus} from '../../actions/steps/getShumaStepStatus';
import {appendStepData} from '../../actions/steps/appendStepData';
import {getStepData} from '../../actions/steps/getStepData';
import {showGlobalErrorMessage} from 'common/actions/globalErrorMessage/showGlobalErrorMessage';
import {getCities} from '../../../../common/actions/general/getCities';
import {getStreets} from '../../../../common/actions/general/getStreets';
import {getFileList} from '../../actions/files/getFileList';

const mapStateToProps = ({
                           stepData: {stepData},
                           shumaProperties: {propertyTypeID},
                           step11FileList: {list: filesListData}
                         }) => ({
  stepData,
  propertyTypeID,
  filesListData
});

export default connect(
  mapStateToProps,
  {
    submitStep,
    uploadFile,
    getShumaStepStatus,
    appendStepData,
    getStepData,
    showGlobalErrorMessage,
    getCities,
    getStreets,
    getFileList
  }
)(Form_1);
